import React from "react";

export default function NewYearFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-6ne9{fill:none;stroke:#000;stroke-miterlimit:10}.cls-6ne7{fill:#fb9581}.cls-6ne9{stroke-width:6.51px}"
            }
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_4"
          data-name="\u0421\u043B\u043E\u0439 4"
        >
          <path
            d="M751.16 465.81h549.97v347.35H751.16z"
            style={{
              fill: "#458671",
            }}
            transform="rotate(157.77 1026.159 639.46)"
          />
          <path
            d="m1259.8 731.6 86.6-35.4L1215 374.67 705.89 582.76l46.5 113.76 421.33-172.22Z"
            style={{
              fill: "#3c7762",
            }}
          />
          <path
            d="m882.81 510.45 131.42 321.53"
            style={{
              strokeWidth: "3.68px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path
            d="M882.23 508.67c5.82-2.38 93.86-114.93 23-151.4s-23 151.4-23 151.4Z"
            style={{
              strokeWidth: "4.17px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path
            d="M882.25 508.66c18.24-33.46 22.49-71.54 10.36-94.44-3.77-7.12-11.72-17.67-20.05-20.69-11.65-4.23-17.46 8.63-18.43 11-7.48 18.04 3.87 59.81 28.12 104.13Z"
            style={{
              strokeWidth: "2.67px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path
            d="M882.4 508.6c-4.54 1.85-114.95-12-95.1-70.46s95.1 70.46 95.1 70.46Z"
            style={{
              strokeWidth: "3.23px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path d="M361.69 715.86h964.78v932.48H361.69z" className="cls-6ne7" />
          <path
            d="M615 1648.33H361.69V715.86h964.78v193.19l-711.47.41Z"
            style={{
              fill: "#e27f71",
            }}
          />
          <path
            d="m361.69 848.78 964.78-.56M528.12 715.86l-4 932.47"
            className="cls-6ne9"
          />
          <path
            d="M529.52 712.32c-21.78 0-452-133.79-272.3-248.16s272.3 248.16 272.3 248.16Z"
            style={{
              strokeWidth: "10.67px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path
            d="M529.46 712.32C427 666.89 363.42 603.38 372.3 554.71c2.77-15.14 14.44-39.26 37.22-50.5 31.84-15.71 67.36 2.63 73.54 6 47.7 26.25 65.94 107.38 46.4 202.11Z"
            style={{
              strokeWidth: "6.83px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path
            d="M528.88 712.32c17 0 353.29-103 212.83-191.05S528.88 712.32 528.88 712.32Z"
            style={{
              strokeWidth: "8.27px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path d="M530.62 851.61h795.85v794.17H530.62z" className="cls-6ne7" />
        </g>
        <g
          id="\u0421\u043B\u043E\u0439_6"
          data-name="\u0421\u043B\u043E\u0439 6"
        >
          <path
            d="M1495.68 735.64c-11.79-2.61-210.24-147.69-83.53-206s83.53 206 83.53 206Z"
            style={{
              strokeWidth: "6.82px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path
            d="M1495.24 735.55c15.08 3.34 357.77-52 271.54-183.37s-271.54 183.37-271.54 183.37Z"
            style={{
              strokeWidth: "8.79px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path
            d="M1495.28 735.56c86.14-25.51 151.41-73.36 161.53-118.89 3.14-14.16 3.12-37.83-8.9-51.53-16.8-19.15-47.53-8-53-5.83-41.75 16.48-81.52 87.28-99.63 176.25Z"
            style={{
              strokeWidth: "5.63px",
              strokeMiterlimit: 10,
              fill: "none",
              stroke: "#000",
            }}
          />
          <path
            d="M920.55 709.4h885.88v885.88H920.55z"
            style={{
              fill: "#fff",
              stroke: "#458671",
              strokeWidth: "13.26px",
              strokeMiterlimit: 10,
            }}
            transform="rotate(12.56 1363.751 1152.633)"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
